import styled from 'styled-components'
export default styled.a`
  display: block;
  position: relative;
  top: -200px;
  visibility: hidden;
`
